module.exports = __webpack_public_path__ + "img/edit-icon.5b1aadb3.svg";